// immutable
import { Map } from "immutable"
// app
import * as types from "./types.js"


export function fetching(state) {
    if (!state) return false
    if (!state.forEach) return false

    let r = false
    state.forEach((item, i) => {
        if (!item.get) return true
        if (item.get("fetching", false)) {
            r = true
            return false
        }
    })
    return r
}

export default function(state = Map(), action) {
    switch (action.type) {
        // GET
        case types.LIST_REQUEST:
            return state.setIn([action.payload.table, "fetching"], true)
        case types.LIST_RECEIVED:
            return state.withMutations(s => s
                .setIn([action.payload.table, "fetching"], false)
                .setIn([action.payload.table, "data"], action.payload.data))
        case types.LIST_ERROR:
            return state.setIn([action.payload.table, "fetching"], false)
        default:
            return state
    }
}



/** WEBPACK FOOTER **
 ** ./src/actions/ref/reducer.js
 **/